// ABOUTME: Orchestrates the optional "send message & mark resolved" composer action.
// ABOUTME: Resolve only runs after a successful send; a resolve failure is reported, not thrown.

export const sendAndMaybeResolve = async ({ send, resolve, resolveAfter }) => {
    await send();

    if (!resolveAfter) return { resolved: false };

    try {
        await resolve();
        return { resolved: true };
    } catch (resolveError) {
        // The message went out; the ticket just stays open. The caller decides
        // how to surface this — it must not look like the send failed.
        return { resolved: false, resolveError };
    }
};
